module.exports = __webpack_public_path__ + "static/water_nubian8-94260561807f783a6000fe1b6829c5d4.jpg";